import { ImpedimentReason, impedimentReasonLabels } from '@/enums/generic';

export const usageTypeList = Object.freeze([
  { name: 'Wohngebäude', value: 'LIVING' },
  { name: 'Gewerbegebäude', value: 'BUSINESS' },
  { name: 'Gemischte Nutzung', value: 'MIXED' },
]);

export const entranceList = Object.freeze([
  { name: 'Haupteingang', value: 'MAIN_ENTRY' },
  { name: 'Seiteneingang', value: 'SIDE_ENTRY' },
  { name: 'Hintereingang', value: 'BACK_ENTRY' },
  { name: 'Sonstiges', value: 'OTHER' },
]);

export const buildingSectionList = Object.freeze([
  { name: 'Vorderhaus', value: 'FRONT_BUILDING' },
  { name: 'Hinterhaus', value: 'BACK_BUILDING' },
  { name: 'Seitenflügel links', value: 'LEFT_WING' },
  { name: 'Seitenflügel rechts', value: 'RIGHT_WING' },
  { name: 'Sonstiges', value: 'OTHER' },
]);

export const responsibilityList = Object.freeze([
  { name: 'Rolle 1', value: 'Rolle1' },
  { name: 'Rolle 2', value: 'Rolle2' },
  { name: 'Rolle 3', value: 'Rolle3' },
  { name: 'Sonstige', value: 'Sonstige' },
]);

export const interiorWallOptions = Object.freeze([
  { value: 'MASONRY', name: 'Mauerwerk' },
  { value: 'REINFORCED_CONCRETE', name: 'Stahlbeton' },
  { value: 'LIGHTWEIGHT_WALLS', name: 'Leichtbauwände' },
]);

export const exteriorWallOptions = Object.freeze([
  { value: 'MASONRY', name: 'Mauerwerk' },
  { value: 'REINFORCED_CONCRETE', name: 'Stahlbeton' },
]);

export const floorOptions = Object.freeze([
  { value: 'HARDWOOD_FLOOR', name: 'Holzfußboden' },
  { value: 'REINFORCED_CONCRETE', name: 'Stahlbeton' },
  { value: 'POLISHED_FLOOR', name: 'Geschütteter Fußboden' },
]);

export const connectionTypeOptions = Object.freeze([
  { value: 'SOCKET', name: 'Steckdose' },
  { value: 'DISTRIBUTION_BOX', name: 'Verteilerdose' },
  { value: 'LIGHT_SWITCH', name: 'Lichtschalter' },
]);

export const mountingTypeOptions = Object.freeze([
  { value: 'SURFACE_MOUNTED', name: 'Aufputz' },
  { value: 'IN_WALL', name: 'Unterputz' },
]);
export const buildingNotAccessibleReasonsList = Object.freeze([
  ImpedimentReason.USER_REFUSES_ACCESS_CURRENTLY,
  ImpedimentReason.NOT_ENCOUNTERED_NAME_CORRECT,
  ImpedimentReason.INSTALLATION_REFUSED,
  ImpedimentReason.SPECIAL_CONSIDERATIONS,
  ImpedimentReason.NEW_APPOINTMENT_NEEDED,
  ImpedimentReason.ACCESS_REFUSED_BY_TECHNICIAN,
  ImpedimentReason.USER_REFUSES_ACCESS_PERMANENTLY,
  ImpedimentReason.UNIT_NOT_FOUND,
  ImpedimentReason.NO_RESPONSE_DESPITE_RINGING,
  ImpedimentReason.CONTACT_PERSON_UNREACHABLE,
  ImpedimentReason.UNREASONABLE,
  ImpedimentReason.OTHER,
].map((value) => ({ name: impedimentReasonLabels[value], value })));

export const compatibilityReasonList = Object.freeze([
  { value: 'FLOOR_HEATING', name: 'Fußbodenheizung' },
  { value: 'ONE_PIPE_HEATING', name: 'Einrohrheizung' },
  { value: 'LTE_COVERAGE_UNAVAILABLE', name: 'LTE Abdeckung nicht vorhanden' },
  { value: 'OTHER', name: 'Sonstiges' },
]);

export const buildingImageKeywordList = [
  'Außenansicht',
  'Gebäude',
  'Treppenhaus',
  'Klingelschild',
  'Fluchtpläne',
];
